const MAIN_PAGE_CODE = 'index'

export { MAIN_PAGE_CODE }
